"use client"

import { CacheProvider } from "@emotion/react"
import { useServerInsertedHTML } from "next/navigation"
import { useState } from "react"
import createEmotionCache from "../theme/createEmotionCache"

export default function EmotionRegistry({
  children,
}: {
  children: React.ReactNode
}) {
  const [cache] = useState(() => createEmotionCache())

  useServerInsertedHTML(() => {
    const inserted = cache.inserted
    if (!inserted || Object.keys(inserted).length === 0) {
      return null
    }

    const styles = Object.keys(inserted)
      .filter((key) => inserted[key] === true)
      .map((key) => {
        const ids = `${cache.key}-${key}`
        const css = cache.registered[key]
        return (
          <style
            key={ids}
            data-emotion={ids}
            dangerouslySetInnerHTML={{ __html: css || "" }}
          />
        )
      })

    // Clear inserted styles to avoid duplicates
    Object.keys(inserted).forEach((key) => {
      delete inserted[key]
    })

    return <>{styles}</>
  })

  return <CacheProvider value={cache}>{children}</CacheProvider>
}
